@if (!pageIsLoading) {
  <wre-core-header [headerConfig]="headerConfig"></wre-core-header>
  <main role="main">
    <wre-core-side-bar>
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </wre-core-side-bar>
  </main>
  <wre-core-footer></wre-core-footer>
}
